import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

import { SV_URL } from '../../@core/utils/utils';

@Injectable({ providedIn: 'root' })
export class DeuProvider {

  public id: string;

  constructor(public http: HttpClient) {}

  saveDeu(data, cli, valor, cod, conta, user, alt, origem) {
    const url: string = SV_URL + '/postDeu';

    const postParams = {
      data: data,
      cli: cli ,
      valor: valor,
      cod: cod,
      conta: conta,
      user: user,
      alt: alt,
      origem: origem,
    };

    this.http.post(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putDeu(id, data, cli, valor, cod, user, alt, origem) {
    const url: string = SV_URL + '/putDeu';

    const postParams = {
      id: id,
      data: data,
      cli: cli ,
      valor: valor,
      cod: cod,
      user: user,
      alt: alt,
      origem: origem,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putDeuStatus(id, cupom, status) {
    return new Promise<void>(resolve => {
      const url: string = SV_URL + '/putDeuStatus';

      const postParams = {
        id: id,
        cupom: cupom,
        status: status,
      };

      this.http.put(url, postParams)
      .subscribe(res => {
        console.log('Enviado Com Sucesso');
        resolve();
        }, error => {
        console.log(error);
        resolve();
      });
    });
  }

  /**
   * Cria um novo registro de Deu em Aberto via POST /postDeuAberto.
   *
   * @param data - Data do registro (YYYY-MM-DD)
   * @param valor - Valor numérico
   * @param origem - Texto de origem
   * @param codigo - Código (opcional; quando preenchido marca como "Conferido")
   * @param user - Usuário que cadastrou
   * @param alt - Data/hora do cadastro
   */
  saveDeuAberto(data, valor, origem, codigo, user, alt) {
    const url: string = SV_URL + '/postDeuAberto';

    const postParams = {
      data: data,
      valor: valor,
      origem: origem,
      codigo: codigo,
      user: user,
      alt: alt,
    };

    this.http.post(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  /**
   * Atualiza um registro existente de Deu em Aberto via PUT /putDeuAberto.
   *
   * @param id - ID do registro
   * @param data - Nova data (YYYY-MM-DD)
   * @param valor - Novo valor
   * @param origem - Nova origem
   * @param codigo - Novo código
   * @param user - Usuário que alterou
   * @param alt - Data/hora da alteração
   */
  putDeuAberto(id, data, valor, origem, codigo, user, alt) {
    const url: string = SV_URL + '/putDeuAberto';

    const postParams = {
      id: id,
      data: data,
      valor: valor,
      origem: origem,
      codigo: codigo,
      user: user,
      alt: alt,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

  putDeuAutorizado(id, user, data, status) {
    const url: string = SV_URL + '/putDeuAutorizado';

    const postParams = {
      id: id,
      user: user,
      data: data,
      status: status,
    };

    this.http.put(url, postParams)
    .subscribe(res => {
      console.log('Enviado Com Sucesso');
      }, error => {
      console.log(error);
    });
  }

}
